import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import usePageMeta from "@/hooks/usePageMeta";
import Hero from "./components/Hero";
import HotPicks from "./components/HotPicks";
import Categories from "./components/Categories";
import Ranking from "./components/Ranking";
import Articles from "./components/Articles";
import AboutBlurb from "./components/AboutBlurb";
import FaqPreview from "./components/FaqPreview";

export default function Home() {
  usePageMeta(
    "小水看番 · 泡面番推荐/三分钟短番，下饭番一口气看完清单",
    "小水看番专注泡面番推荐与三分钟短番盘点，日常搞笑短篇、下饭番、摸鱼短番全收录，按口味分好类，一口气看完不迷路。",
  );

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar overlay />
      <main>
        <Hero />
        <HotPicks />
        <Categories />
        <Ranking />
        <Articles />
        <AboutBlurb />
        <FaqPreview />
      </main>
      <Footer />
    </div>
  );
}